export enum CampaignItemPaymentType {
  CASH = 'cash',
  FREE = 'free',
  INCREASE = 'increase-wallet',
  NONE = 'none'
}

export enum CampaignItemPaymentStatus {
  PAID = 'paid',
  UNPAID = 'unpaid'
}

export enum CampaignItemPaymentItemType {
  CONTENT_ITEM = 'ContentItem',
}
